import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { InstallmentsReceivedPrimary } from "./components/InstallmentsReceivedPrimary";
import { MonthByMonthProfitChart } from "./components/MonthByMonthProfitChart";
import { Cards } from "./Metrics";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useContextDashboardContext } from "src/Contexts/Dashboard/ContextDashboardBroker";
import { FormMetrics } from "./Form/FormMetrics";
import { PieGraphicIncomingExpense } from "./components/PieGraphicOperators";
import { Grid } from "@mui/material";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { EvolutionLives } from "./components/EvolutionLives";

export const PageDashboardBroker = () => {
  const { filterMetricsFilterDashboard } = useContextDashboardContext();
  const { openAside } = useLayoutMainContext();

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<FormMetrics key={1} />]}
        icon={<FilterListIcon />}
        sxStyle={{ margin: "0 0 16px 0", padding: "12px" }}
        title={`Filtro: ${FormatDateBR(
          filterMetricsFilterDashboard.startDate
        )} até ${FormatDateBR(filterMetricsFilterDashboard.endDate)}`}
      />

      <Cards />

      <MonthByMonthProfitChart />

      <InstallmentsReceivedPrimary />

      <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
        <Grid item xs={12} lg={openAside ? 12 : 6.5} xl={7}>
          <EvolutionLives />
        </Grid>

        <Grid item xs={12} lg={openAside ? 12 : 5.5} xl={5}>
          <PieGraphicIncomingExpense />
        </Grid>
      </Grid>
    </>
  );
};
